import { render } from "./PrintPdf.vue?vue&type=template&id=10c6dd46"
import script from "./PrintPdf.vue?vue&type=script&lang=js"
export * from "./PrintPdf.vue?vue&type=script&lang=js"

import "./PrintPdf.vue?vue&type=style&index=0&id=10c6dd46&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__